import React, { FC } from 'react';
import { Trans } from 'react-i18next';
import { Button, ButtonProps } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { Omit } from 'utility-types';

interface IProps extends Omit<ButtonProps, 'classes'>, WithStyles<typeof styles> {
  i18nKey: string;
}

const styles = (theme: Theme) =>
  createStyles({
    button: {
      color: theme.palette.text.primary,
      '&:hover': {
        color: theme.palette.text.secondary,
      },
    },
    icon: {
      color: theme.palette.primary.main,
      fontSize: 36,
    },
  });

const PlusButton: FC<IProps> = ({ i18nKey, classes, ...rest }) => (
  <Button
    className={classes.button}
    startIcon={<AddCircleIcon className={classes.icon} />}
    {...rest}
  >
    <Trans i18nKey={i18nKey} />
  </Button>
);

export default withStyles(styles)(PlusButton);
